import { RouteRecordRaw } from 'vue-router'

const xiangmu: Array<RouteRecordRaw> = [{
    path: '/xiangmu',
    meta: {
        title: "项目管理"
    },
    component: () => import("@/views/xiangmu/list.vue")
}, {
    path: '/xiangmu/:id',
    meta: {
        title: "编辑",
        activeMenu: "/xiangmu"
    },
    component: () => import("@/views/xiangmu/edit.vue")
}, {
    path: '/jieduan',
    meta: {
        title: "编辑",
    },
    component: () => import("@/views/xiangmu/jieduanlist.vue")
}];
export default xiangmu;